import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/modules/layouts/mdx_layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Flex = makeShortcode("Flex");
const Button = makeShortcode("Button");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Flex sx={{
      alignItems: 'center'
    }} mdxType="Flex">
    <img alt="Gatsby" src="https://www.gatsbyjs.com/Gatsby-Monogram.svg" width="60" sx={{
        mr: 2
      }} />
    <span sx={{
        mr: 4
      }}>❤️</span>
	<img alt="MaximumCrash" src="https://rejontaylor.com/Images/crash_contact.svg" width="80" sx={{
        mr: 2,
        ml: 2
      }} />
	<span sx={{
        mr: 4
      }}>❤️</span>
    <img alt="MDXjs" src="https://mdx-logo.now.sh" width="80" sx={{
        ml: 3
      }} />
    </Flex>
    <h1>{`MaximumMDX or: How I Learned to Stop Worrying and Love the Markdown`}</h1>
    <p>{`A `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.com/"
      }}>{`Gatsby`}</a>{` starter kit for leveraging some of the more advanced features of `}<a parentName="p" {...{
        "href": "https://mdxjs.com"
      }}>{`MDXjs`}</a>{` features with a base of content building
helpers to get your next blog/documentation site launched.`}</p>
    <br />
    <br />
    <Button to="/getting_started" mdxType="Button">
Get Started
    </Button>
    <br />
    <Button to="/components/accordion" mdxType="Button">
Check out the components
    </Button>
    <br />
    <Button to="/frontmatter" mdxType="Button">
Learn about the frontmatter controller
    </Button>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      